export class Subnav {
  routing: string;
  navItems: NavItems[];
}

class NavItems {
  navItem: string;
  id: string;
}



// WEBPACK FOOTER //
// C:/Users/anach/Desktop/tengtu-website/src/app/models/subnav.model.ts